var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 15L8.08333 11.4583L9.25 10.2917L11.625 12.6667L16.3333 7.95833L17.5 9.125L11.625 15ZM8.33333 5.83333L15 1.66667H1.66667L8.33333 5.83333ZM8.33333 7.5L1.66667 3.33333V11.6667H5.95833L7.625 13.3333H1.66667C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H15C15.4583 0 15.8507 0.163194 16.1771 0.489583C16.5035 0.815972 16.6667 1.20833 16.6667 1.66667V5.29167L15 6.95833V3.33333L8.33333 7.5Z",
    fill: "#004F6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResubscribe);
export default __webpack_public_path__ + "static/media/Resubscribe.9e75229df429770960a0eb2e0f2748cb.svg";
export { ForwardRef as ReactComponent };